import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IGroupInfo } from '../../../../ts/models/IGroupInfo';
import { updateLocalGroupsLicenseUponLogin } from '../../../actions/spaces/GroupMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { SessionUserSelectors } from '../../../selectors/SessionInfoSelectors';

export const GroupUpdateGrantLicenseModeAction: IEntityAction<IGroupInfo, {}> = {
  name: EntityActionNames.UpdateGroupGrantLicenseMode,
  translateName: Messages.licenseUponLogin,
  isVisible: (targetItems: IGroupInfo[], state: AppState) => {
    const isVisibleWithLUL = FeatureFlags.licenseUponLoginEnabled
                             && (hasLocalGroupsOnly(targetItems));
    return targetItems.length >= 1
      && isVisibleWithLUL;
  },
  isClickable: (availableActions: {}, targetItems: IGroupInfo[], state: AppState) => SessionUserSelectors.canManageUsers(state),
  createReduxAction: (targetItems: IGroupInfo[]) => updateLocalGroupsLicenseUponLogin(targetItems)
};

function hasLocalGroupsOnly(groups: IGroupInfo[]): boolean {
  const result = groups.filter(group => isLocalGroup(group)).length;
  return result === groups.length;
}

function isLocalGroup(group: IGroupInfo): boolean {
  return (group.domainName === undefined || group.domainName === 'local');
}
